import React, {Component} from 'react';
import {DropTarget} from 'react-dnd';
import ClassDndRow from './ClassDndRow';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


const style = {
  height: 'auto',
  minHeight: '50px',
  marginTop: '1rem'
};

const coursesTarget = {
  drop(props, monitor) {
    props.onDrop(monitor.getItem());
  }
};

class DropClassesTarget extends Component {

  render() {
    const {courses, getCourseLocations, moveClass, isOver, canDrop, connectDropTarget, target, linkedCourses, openLinksModal, removeItem} = this.props;

    const isActive = isOver && canDrop;

    let backgroundColor = '#f9f9f9';
    if (isActive) {
      backgroundColor = '#ebe3f2';
    } else if (canDrop) {
      backgroundColor = '#f4fbff';
    }

    return connectDropTarget(
      <div style={{...style, backgroundColor}} className="drop-target">

        {courses && courses.length > 0 ?
          <div className="c-table classes-table">
            <div className="t table table-condensed table-hover">
              <div className="thead">
                <div className="tr background-white">
                  <div className="th name w-200">Name</div>
                  <div className="th w-400">Description</div>
                  <div className="th w-200">Instructor</div>
                  <div className="th w-200">Time</div>
                  <div className="th w-100">Credits</div>
                  <div className="th w-100"></div>
                </div>
              </div>
              <div className="tbody">
                <ReactCSSTransitionGroup
                  transitionName="example"
                  transitionEnterTimeout={500}
                  transitionLeave={false}
                >
                  {courses.map((course, i) => {
                    return <ClassDndRow
                      key={course.id}
                      index={i}
                      course={course}
                      target={target}
                      getCourseLocations={getCourseLocations}
                      moveClass={moveClass}
                      linkedCourses={linkedCourses}
                      openLinksModal={openLinksModal}
                      removeItem={removeItem}
                    />
                  })}
                </ReactCSSTransitionGroup>
                <div className="text-center drop-target-no-items"><h3>{isActive ?
                  'Release to drop' :
                  'Drop Here'
                }</h3></div>
              </div>
            </div>
          </div>
          : <div className="text-center drop-target-no-items"><h3>{isActive ?
          'Release to drop' :
          'Drop Here'
        }</h3></div>}
      </div>
    );
  }
}

export default DropTarget(props => props.accepts, coursesTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))(DropClassesTarget);



// WEBPACK FOOTER //
// ./src/components/rank/DropClassesTarget.js